import css from './GSHiddenImages.module.scss'
import React from 'react'

import Img from 'components/Media/Img'

const GSHiddenImages: React.FC = () => {
  return (
    <div className={css.wrapper}>
      <Img className={css.hidden} src="/goodsandservices/tap2go-drink-error.svg" />
      <Img className={css.hidden} src="/goodsandservices/tap2go-extra-error.svg" />
      <Img className={css.hidden} src="/goodsandservices/tap2go-parking-error.svg" />
      <Img className={css.hidden} src="/goodsandservices/tap2go-skipqueue-error.svg" />
      <Img className={css.hidden} src="/goodsandservices/tap2go-token-error.svg" />
      <Img className={css.hidden} src="/goodsandservices/tap2go-wardrobe-error.svg" />
      <Img className={css.hidden} src="/goodsandservices/details-goback-rounded-big.svg" />
    </div>
  )
}

export default GSHiddenImages
